import { useAppStore } from './index';

/**
 * Number of items awaiting admin action (pending bookings + pending users +
 * pending access requests). Returns 0 for non-admin users.
 *
 * Uses per-slice selectors so the hook only re-renders when one of the three
 * arrays actually changes — not on unrelated store updates.
 */
export const useAdminPendingCount = (): number => {
  const isAdmin = useAppStore(s => s.currentUser?.isAdmin ?? false);
  const bookings = useAppStore(s => s.bookings);
  const users = useAppStore(s => s.users);
  const accessRequests = useAppStore(s => s.accessRequests);

  if (!isAdmin) return 0;
  return bookings.filter(b => b.status === 'pending').length
    + users.filter(u => u.status === 'pending').length
    + accessRequests.filter(r => r.status === 'pending').length;
};
